<template>
	<v-container fluid class="pa-0">
		<v-row>
			<v-col>
				<v-toolbar flat class="my-3" height="36">
					<v-toolbar-title>E-Boekhouden</v-toolbar-title>
				</v-toolbar>
				<e-boekhouden-settings />
			</v-col>
		</v-row>
		<v-row>
			<v-col>
                <api-keys />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import EBoekhoudenSettings from './dialogs/EBoekhoudenSettings'
import ApiKeys from './ApiKeys'
export default {
	components: { EBoekhoudenSettings, ApiKeys },

	methods: {
	},
}
</script>

<style></style>
